var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`notification corner ${_vm.corner} ${_vm.type}`},[_c('div',{staticClass:"notification-close"},[_c('span',{staticClass:"fas fa-times",on:{"click":_vm.close}})]),_c('div',{staticClass:"notification-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"notification-content",domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }